export default {
    language(state) {
        return state.app_language;
    },

    isLogin(state) {
        return !!(state.user.userinfo && state.user.userinfo.access_token);
    },

    dataconterName(state) {
        let dataconterItem = state.common.dataconter.find(item => {
            return item.tenantId == state.common.datacenteruuid
        });
        if(dataconterItem) return dataconterItem.tenantName
        
    }
};


// WEBPACK FOOTER //
// ./src/store/getters.js